import type {DistributorItem} from './distributor-find';
import {detectDistributorType} from './distributor-type';
import ShopFocus from "./icons/icon_map_shops_blue.svg"
import ShopPassive from "./icons/icon_map_shops_yellow.svg"
import PremiumPartnerFocus from "./icons/icon_map_premium_partner_blue.svg"
import PremiumPartnerPassive from "./icons/icon_map_premium_partner_yellow.svg"

/**
 * Return the path to the distributor icon
 */
export const getMapIconForDistributor = (distributor: DistributorItem, isFocused: boolean) => {
  const type = detectDistributorType(distributor)

  switch (type) {
    case "shop":
      return isFocused ? ShopFocus : ShopPassive;
    case "workshop":
    case "workshop24":
      return isFocused ? PremiumPartnerFocus : PremiumPartnerPassive;
  }
}
